import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { hasCadastroPendente } from './AlertApi';
import { isAuthenticated } from 'services/AuthService';
import { useSelector } from 'react-redux';

interface AlertContextProps {
  showAlert: boolean;
  setShowAlert: (value: boolean) => void;
  isLoading: boolean;
}

const AlertContext = createContext<AlertContextProps | undefined>(undefined);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    return { showAlert: false, setShowAlert: () => {}, isLoading: true };
  }
  return context;
};

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const perfil = useSelector((state: any) => state.auth.userData?.perfil);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchAlertStatus() {
      if (perfil && perfil !== 'pufv_professor' && isAuthenticated()) {
        const cadastroPendente = await hasCadastroPendente();
        setShowAlert(cadastroPendente);
      }
      setIsLoading(false);
    }
    if (perfil) {
      fetchAlertStatus();
    }
  }, [perfil]);

  return (
    <AlertContext.Provider value={{ showAlert, setShowAlert, isLoading }}>
      {children}
    </AlertContext.Provider>
  );
};
